module.exports = __webpack_public_path__ + "img/li-in-bug.1b18d461.png";